export const pageview = (GA_MEASUREMENT_ID : string, url : string) => {
    if (typeof window !== "undefined" && window.gtag) {
        window.gtag("config", GA_MEASUREMENT_ID, {
            page_path: url,
        });
    }
};

export const waitForGtag = (callback: () => void, maxAttempts = 10) => { 
    let attempts = 0; 
    const checkGtag = () => { 
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') 
            { callback(); } 
        else if (attempts < maxAttempts) 
            { attempts++; setTimeout(checkGtag, 200); } 
    }; 
    checkGtag(); 
};